import React from 'react'
import { CurrencyInput } from '../../lib'

const GivingRangeInput = ({ title, value, onChange, onEnter }) => {
  const { three, two, one } = value || {}
  return (
    <div className='GivingRangeInput'>
      <CurrencyInput
        label='Last Year'
        status='Giving for the last 12 months'
        onChange={one => onChange({ ...value, one })}
        value={one}
        format="$0,0"
        autoFocus
      />
      <CurrencyInput
        label='Two Years Ago'
        status='Giving for the 12 months prior'
        onChange={two => onChange({ ...value, two })}
        value={two}
        format="$0,0"
      />
      <CurrencyInput
        label='Three Years Ago'
        status='Giving for the 12 months prior to that'
        onChange={three => onChange({ ...value, three })}
        value={three}
        format="$0,0"
      />
    </div>
  )
}

export default GivingRangeInput



// WEBPACK FOOTER //
// ./src/assess/question/GivingRangeInput.js